module.exports = __webpack_public_path__ + "img/china2.6a1f90fe.jpg";